/* eslint-disable no-param-reassign */
import React, { useCallback, memo, MouseEvent, useEffect } from 'react';

import cx from 'classnames';

import classes from './deltaTable.module.scss';

interface IResizeable {
  thRef: HTMLTableCellElement & { x: number };
  width: number;
  autoSizeAllColumns?: boolean;
}

const Resizeable = ({
  thRef,
  width = 80,
  autoSizeAllColumns = false,
}: IResizeable): JSX.Element => {
  const mouseMoveHandler = useCallback(
    (e: globalThis.MouseEvent) => {
      // Determine how far the mouse has been moved
      const dx = e.clientX - thRef.x;

      // Update the width of column
      if (thRef) {
        thRef.style.width = `${width + dx}px`;
        thRef.style.minWidth = `${width + dx}px`;
        if (autoSizeAllColumns) {
          thRef.style.width = `${width}px`;
          thRef.style.minWidth = `${width}px`;
        }
      }
    },
    [autoSizeAllColumns, thRef, width]
  );

  // When user releases the mouse, remove the existing event listeners
  const mouseUpHandler = useCallback(() => {
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
  }, [mouseMoveHandler]);

  const handleMouseDown = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      const x = e.clientX;
      thRef.x = x;
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    },
    [mouseMoveHandler, mouseUpHandler, thRef]
  );

  useEffect(() => {
    if (autoSizeAllColumns && thRef) {
      thRef.style.width = `${width}px`;
      thRef.style.minWidth = `${width}px`;
    }
  }, [autoSizeAllColumns, thRef, width]);

  return (
    (<div
      role="button"
      tabIndex={-1}
      className={cx(classes.resizer)}
      onMouseDown={handleMouseDown}
      draggable
      data-palette="Resizeable">
      {' '}
    </div>)
  );
};

export default memo(Resizeable);
